import { merge } from 'lodash';
import { bigQuery, logger } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { PAGE_NAME } from '../constants';
import { bqEvents } from './events';

const getCommonFields = () => {
    const { organizationId, userId, userGuid, pageCtxId } = getContext();

    return {
        group: 'user_action',
        feature: {
            name: 'recommendations',
        },
        page: {
            ctx_id: pageCtxId,
            name: PAGE_NAME,
        },
        user: {
            id: userId,
            uid: userGuid,
        },
        organization: {
            id: organizationId,
        },
        event_source: PAGE_NAME,
    };
};

export const sendBqEvent = (event: ReturnType<ValuesOf<typeof bqEvents>>) => {
    if (typeof window === 'undefined') {
        // This is because it's using module variables for biContext
        // If we were to use it on the server, users would override each other
        logger.error('sendBqEvent is not supported on server side');
        return;
    }

    const enrichedEvent = merge({}, getCommonFields(), event);

    bigQuery.send(enrichedEvent);
};

export * from './events';
